import { createContext } from 'react';

export interface ModalState {
  isOpen: boolean;
  type: string | null;
  props: Record<string, unknown>;
}

export interface ModalContextValue {
  state: ModalState;
  openModal: (type: string, props?: Record<string, unknown>) => void;
  closeModal: () => void;
}

export const defaultModalState: ModalState = {
  isOpen: false,
  type: null,
  props: {},
};

export const ModalContext = createContext<ModalContextValue>({
  state: defaultModalState,
  openModal: () => {},
  closeModal: () => {},
});
